var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PageLoader bg-white"},[_c('q-spinner-dots',{attrs:{"color":"secondary","size":_vm.$q.screen.gt.xs ? '15rem' : '10rem'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }